export default {
    navbarHeight: '88',
    containerWidth: '1440',
    inputMaxWidth: '735',
    inputMediumMaxWidth: '360',
    inputRowGap: '24',
};
